import { render, staticRenderFns } from "./userActivity.vue?vue&type=template&id=4501e02f&scoped=true"
import script from "./userActivity.vue?vue&type=script&lang=js"
export * from "./userActivity.vue?vue&type=script&lang=js"
import style0 from "./userActivity.vue?vue&type=style&index=0&id=4501e02f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4501e02f",
  null
  
)

export default component.exports